import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazyNamed(() => import('./Helmet.tsx'), 'Helmet'),
  AiChat: lazyNamed(() => import('./pages/Chat/index.tsx'), 'AiChat'),
  AiSettingsAgents: lazyNamed(() => import('./pages/Settings/AgentsPage.tsx'), 'AgentsPage'),
  AiSettingsAgentForm: lazyNamed(() => import('./pages/Settings/AgentForm/index.tsx'), 'AgentFormPage'),
  AiSettingsMcpServers: lazyNamed(() => import('./pages/Settings/McpServersPage.tsx'), 'McpServersPage'),
  AiSettingsMcpServerForm: lazyNamed(() => import('./pages/Settings/McpServerForm/index.tsx'), 'McpServerFormPage'),
  AiSettingsBrandKits: lazyNamed(() => import('./pages/Settings/BrandKitsPage.tsx'), 'BrandKitsPage'),
  AiSettingsBrandKitForm: lazyNamed(() => import('./pages/Settings/BrandKitForm/index.tsx'), 'BrandKitFormPage'),
  AiSettingsUsage: lazyNamed(() => import('./pages/Settings/UsagePage.tsx'), 'UsagePage'),
};
